import React, { useState } from 'react';
import {
    Button,
    Modal,
    Form,
    Typography,
    notification, Row, Col
} from 'antd';
import {AdminHttpService} from "../../../services/Http/SearchTableService";
import {AnyObject} from "./BasicTable";

export enum BasicFormMethod {
    CREATE,
    // PUT
}
export interface LoadOperatorsProps {
    isOpen: boolean;
    onOk: () => void;
    onCancel: () => void;
    inputFields: React.ReactNode[];
    urlPath:string;
    method:BasicFormMethod;
    title?:string;
}

export function BasicFormModal<T extends AnyObject>(props: LoadOperatorsProps) {
    const [loading, setLoading] = useState<boolean>(false);
    const [saveDisabled, setSaveDisabled] = useState<boolean>(true);
    const [form] = Form.useForm();

    const handleSave = async () => {
        console.log("Received save request",form.getFieldsValue())
        setLoading(true)

        if(props.method === BasicFormMethod.CREATE){
            try {
                await AdminHttpService.create<T>(props.urlPath, form.getFieldsValue());
                notification['success']({
                    message: 'Operazione completata con successo'
                });
                props.onOk();
            } catch (e) {
                console.log(e);
                notification['error']({
                    message: 'Operazione fallita con errore'
                });
            } finally {
                setLoading(false);
            }
        }
    };


    const handleValuesChange = async () => {
        try {
            await form.validateFields();
            setSaveDisabled(false);
        } catch (errorInfo:any) {
            if(errorInfo.errorFields.length === 0)
                setSaveDisabled(false);
            else
                setSaveDisabled(true);
        }
    };

    return <>
        <Modal open={props.isOpen}
               onCancel={props.onCancel}
               width={"50%"}
               title={props.title}
               footer={(_, {OkBtn, CancelBtn}) => (
                   <>
                       <Button key="close" onClick={props.onCancel}>
                           Chiudi
                       </Button>
                       <Button key="upload" type="primary"
                               onClick={form.submit} loading={loading} disabled={saveDisabled} >
                           {loading ? 'Caricamento in corso...' : 'Salva'}
                       </Button>
                   </>
               )}
               modalRender={dom => (
                   <Form form={form} onFinish={handleSave} layout="vertical" className={"create-form-modal"}
                        onValuesChange={handleValuesChange}>
                       {dom}
                   </Form>
               )}
        >
            <div style={{ maxWidth: '700px', margin: '0 auto' }}>
                <Row gutter={16}>
                    {props.inputFields.map((field, index) => {
                        return (
                            <Col span={12} key={index}>
                                {field}
                            </Col>
                        );
                    })}
                </Row>
            </div>
        </Modal>
    </>
}
